import {
  Grid,
  List,
  ListItem,
  ListItemText,
  Paper,
  Typography,
} from "@material-ui/core";

export const AssetNameViewer = ({ procedureResults }: any) => {

  const lastCalibrationDate =
    procedureResults?.last_calibration_date?.[0] ?? null;


  if (
    procedureResults === undefined ||
    procedureResults.assets === undefined ||
    procedureResults.assets.length === 0
  ) {
    return (
      <ListItem>
        <ListItemText primary="No Assets" />
      </ListItem>
    );
  }



  return (
    <Paper variant="outlined">
      <Grid
        container
        direction="row"
        alignItems="center"
        justify="space-between"
      >
        <Grid item xs={12} style={{ margin: "8px" }}>
          <Typography variant="h5" style={{ fontWeight: "bold" }}>Asset Names</Typography>
          {procedureResults?.assets?.length ? (
            procedureResults.assets.map((asset: any) => (
              <Typography variant="body1" style={{ marginTop: "4px" }}>
                {asset[0]}
              </Typography>
            ))
          ) : (
            <Typography variant="body1" style={{ marginTop: "4px" }}>
              No Assets
            </Typography>
          )}
        </Grid>
        {/* <Grid item xs={12}>
          <List>{renderListContent()}</List>

        </Grid> */}
        {lastCalibrationDate ? (
          <Grid item xs={12} style={{ margin: "8px" }}>
            <Typography variant="h6" style={{ fontWeight: "bold" }}>
              Last Calibration Date
            </Typography>
            <Typography variant="body1">
              {lastCalibrationDate.substring(0, 10)}
            </Typography>
          </Grid>
        ) : (
          <Grid item xs={12} style={{ margin: "8px" }}>

            <Typography variant="body1">
              No Calibration date
            </Typography>
          </Grid>
        )
        }
        
      </Grid>
    </Paper>
  );
};
